import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Icon } from '@treelab/panda'

import { Warning } from '../../constants/svg'

import { Container, MessageContainer, PlaceholderContainer, PlaceholderVertical, PlaceholderTitle, PlaceholderMessage } from './styled'

const NotPermission: React.FC = () => {
  return (
    <Container>
      <MessageContainer>
        <Icon icon={Warning} size={{ width: 16, height: 16 }} />
        <FormattedMessage id="error.not.has.permission" />
      </MessageContainer>
      <PlaceholderContainer>
        <PlaceholderVertical />
        <PlaceholderTitle />
        <PlaceholderMessage />
      </PlaceholderContainer>
      <PlaceholderContainer>
        <PlaceholderVertical />
        <PlaceholderTitle />
        <PlaceholderMessage />
      </PlaceholderContainer>
      <PlaceholderContainer>
        <PlaceholderVertical />
        <PlaceholderTitle />
        <PlaceholderMessage />
      </PlaceholderContainer>
    </Container>
  )
}

export default NotPermission
